import http from "@/http/http.js";
// let baseUrl = "/api/web/action/licenseQuery/springBoard";

let baseURL = "";
if (process.env.NODE_ENV == 'development') {//开发环境
    baseURL = '/api/web/action/tmQuery/springBoard';
} else if (process.env.NODE_ENV == 'production') {//生产环境
    baseURL = '/web/action/tmQuery/springBoard';
}
let basePayURL = ""
if (process.env.NODE_ENV == 'development') {//开发环境
    basePayURL = '/api/web/payment/paymentApi/springBoard';
} else if (process.env.NODE_ENV == 'production') {//生产环境
    basePayURL = '/web/payment/paymentApi/springBoard';
}

//专业版详情
let baseURL1 = "";
if (process.env.NODE_ENV == 'development') {//开发环境
    baseURL1 = '/api/web/opaction/order/springBoard';
} else if (process.env.NODE_ENV == 'production') {//生产环境
    baseURL1 = '/web/opaction/order/springBoard';
}

//下载事实与理由模板
let baseFactURL = "";
if (process.env.NODE_ENV == 'development') {//开发环境
    baseFactURL = '/api/web/opaction/tmReview/springBoard';
} else if (process.env.NODE_ENV == 'production') {//生产环境
    baseFactURL = '/web/opaction/tmReview/springBoard';
}
//下载评审代理委托书模板
let baseReviewURL = "";
if (process.env.NODE_ENV == 'development') {//开发环境
    baseReviewURL = '/api/web/opaction/tmReview/springBoard';
} else if (process.env.NODE_ENV == 'production') {//生产环境
    baseReviewURL = '/web/opaction/tmReview/springBoard';
}

//专业版详情
let baseSCCURL = "";
if (process.env.NODE_ENV == 'development') {//开发环境
    baseSCCURL = '/api/web/payment/paymentApi/springBoard';
} else if (process.env.NODE_ENV == 'production') {//生产环境
    baseSCCURL = '/web/payment/paymentApi/springBoard';
}


let baseURL2 = "";
if (process.env.NODE_ENV == 'development') {//开发环境
    baseURL2 = '/api/web/opaction/tmReview/springBoard';
} else if (process.env.NODE_ENV == 'production') {//生产环境
    baseURL2 = '/web/opaction/tmReview/springBoard';
}
//提交复审清单
let baseURL4 = "";
if (process.env.NODE_ENV == 'development') {//开发环境
    baseURL4 = '/api/web/opaction/tmReview/springBoard';
} else if (process.env.NODE_ENV == 'production') {//生产环境
    baseURL4 = '/web/opaction/tmReview/springBoard';
}


// 产品列表-根据产品大类获取-应用中心
let baseProURL = ""
if (process.env.NODE_ENV == 'development') {//开发环境
    baseProURL = '/api/web/action/product/springBoard';
} else if (process.env.NODE_ENV == 'production') {//生产环境
    baseProURL = '/web/action/product/springBoard';
}

// 根据驳回通知书获取内容
let baseRejURL = ""
if (process.env.NODE_ENV == 'development') {//开发环境
    baseRejURL = '/api/web/opaction/tmReview/springBoard';
} else if (process.env.NODE_ENV == 'production') {//生产环境
    baseRejURL = '/web/opaction/tmReview/springBoard';
}

let baseAddURL = "";
if (process.env.NODE_ENV == 'development') {//开发环境
    baseAddURL = '/api/web/action/product/springBoard';
} else if (process.env.NODE_ENV == 'production') {//生产环境
    baseAddURL = '/web/action/product/springBoard';
}

let baseCreatURL = "";
if (process.env.NODE_ENV == 'development') {//开发环境
    baseCreatURL = '/api/web/opaction/order/springBoard';
} else if (process.env.NODE_ENV == 'production') {//生产环境
    baseCreatURL = '/web/opaction/order/springBoard';
}

// 产品列表-根据产品大类获取-应用中心
export function getProductListCards(params) {
    return http.post(baseAddURL, {
      actionType: 'getProductList',
      actionBody: {
        pathCode: params,
      },
    });
  }

// 根据驳回通知书获取内容
export function getRejContent(params) {
    return http.post(baseRejURL, {
      actionType: 'getPDFInfo',
      actionBody: {
        url: params,
      },
    });
  }

//下载评审代理委托书模板
export function dLoadRevie(params) {
    return http.post(baseReviewURL, {
        actionType: 'getEntrustDoc',
        actionBody: params
    })
}

//下载事实与理由模板
export function downLoadFacts(params) {
    return http.post(baseFactURL, {
        actionType: 'composeDocAndDownload',
        actionBody: params
    })
}

// 商标申请号查询
export function enquiryNumber(params) {
    return http.post(baseURL, {
        actionType: "findTrademarkzchAccurate",
        actionBody: params
    });
}
export function getNcList(params) {
    return http.post(baseURL, {
        actionType: "tradeMarkDetail",
        actionBody: params
    });
}
//统一社会信用代码查询
export function SCCode(params) {
    return http.post(baseURL, {
        actionType: "getCompanyInfoNoUser",
        actionBody: params
    })
}


//创建商标复审单订单(自助版)
export function createReviewOrder(params){
    return http.post(baseCreatURL,{
        actionType: 'addOrder',
        actionBody: params
    })
}
// 获取订单列表信息
export function getOrderList(params) {
    return http.post(baseURL1, {
        actionType: 'getOrderInfo',
        actionBody: params
    })
}
// 获取订单详情信息
export function getOrderDetails(params) {
    return http.post(baseURL1, {
        actionType: 'getOrderDetails',
        actionBody: params
    })
}
// 删除订单信息
export function delOrder(params) {
    return http.post(baseURL1, {
        actionType: 'delOrder',
        actionBody: params
    })
}

//驳回复审专业版详情数据
export function detailpaydata(params){
    return http.post(baseURL1, {
        actionType: "getOrderDeliveryInfo",
        actionBody: params
    });
}

//驳回复审清单提交
export function bsubmit(actionBody){
    return http.post(baseURL4, {
        actionType: "addReviewList",
        actionBody: actionBody
    });
}
// 商标驳回列表+模糊查询
export function getReOrderList(params) {
    return http.post(baseURL2, {
        actionType: 'getReOrderList',
        actionBody: params
    })
}

// 官文列表
export function getOfficalList(params){
    return http.post(baseURL2, {
        actionType: 'getOfficalList',
        actionBody: params
    })
}
// 上传驳回通知书返回信息接口
export function bhtzsinfo(params){
    return http.post(baseURL2, {
        actionType: 'getPDFInfo',
        actionBody:{
            url:params
        }
    })
}
// 获取支付二维码
export function getQrCode(params){
    return http.post(basePayURL, {
        actionType: 'getOrderQrCode',
        actionBody:params
    })
}
// 下载事实与理由模板
export function ssylydown(params){
    return http.post(baseURL2, {
        actionType: 'composeDocAndDownload',
        actionBody:params
    })
}
//评审代理委托书模板下载
export function wtsupload(params){
    return http.post(baseURL2, {
        actionType: 'getEntrustDoc',
        actionBody:params
    })
}